var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "#E9EFF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 17.9035V11.732C21.3332 10.4065 20.2587 9.33203 18.9332 9.33203H15.0301L10.6665 13.6177V20.2654C10.6665 21.5908 11.741 22.6654 13.0665 22.6654H13.0907",
    stroke: "#CC214F",
    strokeWidth: 1.14286,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 14H13.7332C14.6168 14 15.3332 13.2837 15.3332 12.4V10",
    stroke: "#CC214F",
    strokeWidth: 1.14286,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1539 19.7305C16.6515 19.7305 17.0384 19.8328 17.3144 20.0375C17.5905 20.2423 17.7285 20.5457 17.7285 20.948C17.7285 21.3682 17.5932 21.6851 17.3226 21.8988C17.052 22.1125 16.6897 22.2194 16.2356 22.2194H15.8269V23.4638H14.9333V19.7305H16.1539ZM16.1593 21.5837C16.37 21.5837 16.5307 21.5343 16.6415 21.4355C16.7523 21.3368 16.8077 21.1743 16.8077 20.948C16.8077 20.5565 16.5861 20.3608 16.1429 20.3608H15.8269V21.5837H16.1593ZM19.2542 19.7305C19.8463 19.7305 20.3212 19.8625 20.679 20.1264C21.0368 20.3904 21.2157 20.8743 21.2157 21.5783C21.2157 22.2714 21.0414 22.759 20.6926 23.0409C20.3439 23.3228 19.8917 23.4638 19.3359 23.4638H18.2026V19.7305H19.2542ZM19.0962 20.3716V22.8227H19.3904C19.6846 22.8227 19.908 22.732 20.0606 22.5507C20.2132 22.3693 20.2894 22.0452 20.2894 21.5783C20.2894 21.2586 20.2513 21.0108 20.175 20.8349C20.0987 20.6589 19.9952 20.5377 19.8644 20.4712C19.7337 20.4048 19.572 20.3716 19.3795 20.3716H19.0962ZM21.7497 23.4638V19.7305H24L23.9074 20.3608H22.6433V21.352H23.7439V21.9823H22.6433V23.4638H21.7497Z",
    fill: "#CC214F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePdf);
export default __webpack_public_path__ + "static/media/circlePDF.85def2a07a3ebeb5b322ee389f525d83.svg";
export { ForwardRef as ReactComponent };